var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "salePrice-content",
      class: { "has-crossprice": _vm.hasCrossPrice }
    },
    [
      _vm.showCrossPrice && _vm.hasCrossPrice
        ? _c(
            "div",
            {
              staticClass: "crossprice d-block",
              class: { "is-special-offer": _vm.hasSpecialOffer }
            },
            [
              _vm.hasSpecialOffer
                ? [
                    _c(
                      "del",
                      { staticClass: "text-muted small text-appearance" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("itemCrossPrice")(
                              _vm.currentVariation.prices.default.unitPrice
                                .formatted,
                              true
                            )
                          )
                        )
                      ]
                    )
                  ]
                : [
                    _c(
                      "del",
                      { staticClass: "text-muted small text-appearance" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.prices.rrp.unitPrice.formatted
                          )
                        )
                      ]
                    ),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$translate(
                            "ETCeresCoconut::Template.singleItemUVP"
                          )
                        ) +
                        "\n    "
                    )
                  ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "salePrice d-flex" }, [
        _vm.showCrossPrice && _vm.hasCrossPrice
          ? _c(
              "div",
              {
                staticClass: "CrosspriceDiscount",
                class: { "is-special-offer": _vm.hasSpecialOffer }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm._f("numberFormat")(
                        (1 -
                          _vm.currentVariation.prices.default.unitPrice.value /
                            _vm.currentVariation.prices.rrp.unitPrice.value) *
                          -100,
                        0
                      )
                    ) +
                    "%\n    "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "price h1",
            class: { "is-special-offer": _vm.hasSpecialOffer }
          },
          [
            _c(
              "div",
              { staticClass: "saleFont" },
              [
                _vm.showDynamicPrice
                  ? [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.dynamicVariationPrice",
                              {
                                price: _vm.$options.filters.currency(
                                  _vm.variationTotalPrice,
                                  _vm.currentVariation.prices.default.currency
                                )
                              }
                            )
                          ) +
                          "\n        "
                      )
                    ]
                  : [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("currency")(
                              _vm.variationTotalPrice,
                              _vm.currentVariation.prices.default.currency
                            )
                          ) +
                          "\n        "
                      )
                    ]
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "saleInfo" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$translate("Ceres::Template.itemInclVAT")) +
                  "\n      " +
                  _vm._s(_vm.$translate("Ceres::Template.itemExclusive")) +
                  "\n        "
              ),
              _c(
                "span",
                {
                  staticClass: "openShippingCostsWrapper",
                  staticStyle: { cursor: "pointer" }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$translate("Ceres::Template.itemShippingCosts"))
                  )
                ]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("graduated-prices", { staticClass: "mt-2" }),
      _vm._v(" "),
      _c("div", { staticClass: "unitPrice" }, [
        _vm.currentVariation.unit
          ? _c(
              "div",
              {
                staticClass: "base-price text-muted",
                class: {
                  "is-single-piece":
                    _vm.currentVariation.unit &&
                    _vm.currentVariation.unit.content === 1 &&
                    _vm.currentVariation.unit.unitOfMeasurement === "C62"
                }
              },
              [
                _vm.currentVariation.variation.mayShowUnitPrice
                  ? _c("div", [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.singleItemUnitPrice"
                            )
                          ) +
                          "\n        "
                      ),
                      _c("span", { staticClass: "base-price-value" }, [
                        _vm._v(
                          "\n                      " +
                            _vm._s(
                              _vm._f("specialOffer")(
                                _vm.variationGraduatedPrice.basePrice,
                                _vm.currentVariation.prices,
                                "basePrice"
                              )
                            ) +
                            "\n                  "
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.currentVariation.variationProperties
        ? [
            _vm._l(_vm.currentVariation.variationProperties, function(
              variation
            ) {
              return [
                _vm._l(variation.properties, function(properties) {
                  return [
                    properties.id == 414
                      ? [
                          _c("div", {
                            staticClass: "advertising",
                            domProps: {
                              innerHTML: _vm._s(
                                variation.properties[0].values.description
                              )
                            }
                          })
                        ]
                      : _vm._e()
                  ]
                })
              ]
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }